module.exports = __webpack_public_path__ + "img/marker-pin-03.120650af.svg";